module.exports = __webpack_public_path__ + "img/BG-section-2.1a9752b5.jpeg";